import { ToastProps } from '@chakra-ui/react';
import { SectionProps } from '../../components/molecules/studentLeftNav/types';
import { ImmigrationStatusShareCodeDoc } from 'types';

export type THeaderTabOption = 'casProcess' | 'notInvited';

export interface IModal {
  isFinanceDocumentModal?: boolean;
  isFollowUpDocumentModal?: boolean;
  sponsorType?: string;
  docType?: string | null;
  sponsorKey?: string;
  docKey?: string | null;
  modalTitle?: string;
  fileNames?: string[];
  isUpload?: boolean;
  shareCode?: ImmigrationStatusShareCodeDoc;
  isInterviewDocumentModal?: boolean;
  isRecordedInterviewDocumentModal?: boolean;
  interviewType?: string;
  eventType?: string;
  eventKey?: string;
  interviewHash?: string;
  attemptHash?: string;
}

export interface UIState {
  readonly isLoading: boolean;
  readonly isContextLoading?: boolean;
  readonly isSocketUp: boolean;
  readonly openModal: IModal | null;
  readonly uniDashRowScrollIndex: number;
  readonly headerTab: THeaderTabOption;
  readonly sections: SectionProps[];
  readonly navigateStudentRecord: boolean;
  readonly toastProps: ToastProps;
  readonly session?: any; // ISessionContext from shared-components
}

export enum UIActionTypes {
  UPDATE_CONNECTION_STATUS = '@@ui/UPDATE_CONNECTION_STATUS',
  UPDATE_SCROLL_INDEX = '@@ui/UPDATE_SCROLL_INDEX',
  SET_HEADER_TAB = '@@ui/SET_HEADER_TAB',
  OPEN_DOCUMENT_MODAL = '@@ui/OPEN_DOCUMENT_MODAL',
  CLOSE_MODAL = '@@ui/CLOSE_MODAL',
  OPEN_UPLOAD_MODAL = '@@ui/OPEN_UPLOAD_MODAL',
  OPEN_FINANCE_UPLOAD_MODAL = '@@ui/OPEN_FINANCE_UPLOAD_MODAL',
  OPEN_FINANCE_DOCUMENT_MODAL = '@@ui/OPEN_FINANCE_DOCUMENT_MODAL',
  OPEN_FOLLOW_UP_DOCUMENT_MODAL = '@@ui/OPEN_FOLLOW_UP_DOCUMENT_MODAL',
  OPEN_FOLLOW_UP_UPLOAD_MODAL = '@@ui/OPEN_FOLLOW_UP_UPLOAD_MODAL',
  OPEN_INTERVIEW_UPLOAD_MODAL = '@@ui/OPEN_INTERVIEW_UPLOAD_MODAL',
  OPEN_RECORDED_INTERVIEW_UPLOAD_MODAL = '@@ui/OPEN_RECORDED_INTERVIEW_UPLOAD_MODAL',
  DELETE_FILE = '@@ui/DELETE_FILE',
  SET_IS_LOADING = '@@ui/SET_IS_LOADING',
  SET_CONTEXT_LOADING = '@@auth/SET_CONTEXT_LOADING',
  SET_CONTEXT_SUCCESS = '@@auth/SET_CONTEXT_SUCCESS',
  OPEN_TOAST_MESSAGE = '@@ui/OPEN_TOAST_MESSAGE',
  CLEAR_TOAST_MESSAGE = '@@ui/CLEAR_TOAST_MESSAGE',
}
